"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_2 = require("swiper/react");
var swiper_1 = __importStar(require("swiper"));
require("swiper/swiper.scss");
require("swiper/components/effect-fade/effect-fade.scss");
var data_service_1 = __importDefault(require("../../services/data.service"));
var meta_1 = __importDefault(require("../shared/meta"));
var overlay_1 = __importDefault(require("../shared/overlay"));
var episode_comments_1 = __importDefault(require("./episode-comments"));
var episode_languages_1 = __importDefault(require("./episode-languages"));
var episode_password_1 = __importDefault(require("./episode-password"));
var episode_list_1 = __importDefault(require("./episode-list"));
var spinner_1 = __importDefault(require("../shared/spinner"));
var action_button_1 = __importDefault(require("../shared/action-button"));
var loading_1 = __importDefault(require("../shared/loading"));
var snackbar_1 = __importDefault(require("../shared/snackbar"));
var web_view_service_1 = __importDefault(require("../../services/web-view.service"));
var lang_service_1 = __importDefault(require("../../services/lang.service"));
var sharer_1 = __importDefault(require("../shared/sharer"));
swiper_1.default.use([swiper_1.Navigation, swiper_1.Keyboard]);
var pageArrowLeft;
var pageArrowRight;
var pageContainer;
var baseState = {
    comic: undefined,
    episode: undefined,
    pageNumber: 1,
    loadedImages: {},
    isCommentsOverlayShown: false,
    isEpisodesOverlayShown: false,
    isLanguageOverlayShown: false,
    isEpisodePasswordVerified: false,
    isTitleSnackbarShown: false,
    titleSnackbarTimeout: undefined,
    isLastSnackBarShown: false,
    lastSnackbarTimeout: undefined,
    currentImgUrl: '',
    isFirstEpisode: true,
    isLastEpisode: true,
    prevEpisode: undefined,
    nextEpisode: undefined,
};
var Episode = (function (_super) {
    __extends(Episode, _super);
    function Episode(props) {
        var _this = _super.call(this, props) || this;
        _this.componentIsMounted = false;
        _this.state = __assign({}, baseState);
        _this.resetState = function (callback) {
            _this.setState(__assign({}, baseState), callback);
        };
        _this.backButtonPressedHandler = function () {
            var _a = _this.state, isCommentsOverlayShown = _a.isCommentsOverlayShown, isEpisodesOverlayShown = _a.isEpisodesOverlayShown, isLanguageOverlayShown = _a.isLanguageOverlayShown;
            if (isCommentsOverlayShown) {
                _this.hideCommentsOverlay();
            }
            else if (isEpisodesOverlayShown) {
                _this.hideEpisodesOverlay();
            }
            else if (isLanguageOverlayShown) {
                _this.hideLangOverlay();
            }
            else {
                _this.goHome();
            }
        };
        _this.redirectToPage = function (url) { return _this.props.history.push("".concat(url, "/").concat(_this.props.location.search)); };
        _this.goToPage = function (newPage) {
            var _a = _this.state, comic = _a.comic, episode = _a.episode;
            if (newPage === 0 || newPage > episode.pageCount)
                return;
            _this.redirectToPage("/".concat(comic.slug, "/episodes/").concat(episode.slug, "/").concat(newPage));
        };
        _this.showOverlay = function (whereToGo) {
            var currentUrl = _this.props.match.url;
            var middleSlash = currentUrl.slice(-1) === '/' ? '' : '/';
            _this.redirectToPage("".concat(_this.props.match.url).concat(middleSlash).concat(whereToGo));
        };
        _this.showCommentsOverlay = function () { return _this.showOverlay('comments'); };
        _this.showEpisodesOverlay = function () { return _this.showOverlay('episode-list'); };
        _this.showLanguageOverlay = function () { return _this.showOverlay('languages'); };
        _this.hideEpisodesOverlay = function () {
            _this.props.history.goBack();
        };
        _this.hideCommentsOverlay = function () {
            _this.props.history.goBack();
        };
        _this.hideLangOverlay = function () {
            _this.props.history.goBack();
        };
        _this.hidePasswordOverlay = function () {
            _this.goHome();
        };
        _this.goHome = function () {
            return _this.redirectToPage("/".concat(_this.state.comic.slug));
        };
        _this.goToEpisode = function (episode) {
            if (episode.id !== _this.state.episode.id)
                _this.redirectToPage("/".concat(_this.state.comic.slug, "/episodes/").concat(episode.slug, "/1"));
        };
        _this.goToNextEpisode = function () {
            _this.redirectToPage("/".concat(_this.state.comic.slug, "/episodes/").concat(_this.state.episode.nextEpisodeSlug, "/1"));
        };
        _this.changeLanguage = function (newLang) {
            var _a = _this.state, comic = _a.comic, episode = _a.episode, pageNumber = _a.pageNumber;
            lang_service_1.default.setComicLang(newLang);
            var langString = newLang === comic.defaultLang ? '' : "?lang=".concat(newLang);
            _this.props.history.push("/".concat(comic.slug, "/episodes/").concat(episode.slug, "/").concat(pageNumber, "/").concat(langString));
        };
        _this.passwordVerifiedHandler = function () {
            _this.setState({
                isEpisodePasswordVerified: true,
            });
        };
        _this.getImgUrl = function (pageNumber) {
            var _a;
            var episode = _this.state.episode;
            return (_a = episode === null || episode === void 0 ? void 0 : episode.media) === null || _a === void 0 ? void 0 : _a.pages[pageNumber - 1];
        };
        _this.handleScroll = function (evt) {
            pageArrowLeft.current.style.top = "".concat(evt.target.scrollTop, "px");
            pageArrowLeft.current.style.bottom = "".concat(-1 * evt.target.scrollTop, "px");
            pageArrowRight.current.style.top = "".concat(evt.target.scrollTop, "px");
            pageArrowRight.current.style.bottom = "".concat(-1 * evt.target.scrollTop, "px");
        };
        pageArrowLeft = react_1.default.createRef();
        pageArrowRight = react_1.default.createRef();
        pageContainer = react_1.default.createRef();
        return _this;
    }
    Episode.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, path, params, _b, comicSlug, episodeSlug, pageNumber, comic, lang, episode, intPageNumber, _c, prevEpisode, nextEpisode, isLastPage_1, err_1;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (web_view_service_1.default.isWebView()) {
                            web_view_service_1.default.sendEvent({ name: 'reachedEpisode' });
                            window.addEventListener('backButtonPressed', this.backButtonPressedHandler);
                        }
                        this.componentIsMounted = true;
                        _a = this.props.match, path = _a.path, params = _a.params;
                        _b = params, comicSlug = _b.comicSlug, episodeSlug = _b.episodeSlug, pageNumber = _b.pageNumber;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 4, , 5]);
                        return [4, data_service_1.default.getComicBySlug(comicSlug, true)];
                    case 2:
                        comic = _d.sent();
                        lang = lang_service_1.default.getComicLang();
                        return [4, data_service_1.default.getCachedEpisodeBySlug(comicSlug, episodeSlug, lang, true)];
                    case 3:
                        episode = _d.sent();
                        intPageNumber = parseInt(pageNumber);
                        if (!episode ||
                            !comic ||
                            isNaN(intPageNumber) ||
                            intPageNumber < 1 ||
                            intPageNumber > episode.pageCount) {
                            this.props.history.push('/404');
                        }
                        else {
                            _c = data_service_1.default.getPrevAndNextEpisodes(episode, comic.episodes), prevEpisode = _c[0], nextEpisode = _c[1];
                            isLastPage_1 = intPageNumber === episode.pageCount;
                            this.setState({
                                comic: comic,
                                episode: episode,
                                pageNumber: Number(pageNumber),
                                prevEpisode: prevEpisode,
                                nextEpisode: nextEpisode,
                                isFirstEpisode: !prevEpisode,
                                isLastEpisode: !nextEpisode,
                                isEpisodesOverlayShown: path.split('/').includes('episode-list'),
                                isCommentsOverlayShown: path.split('/').includes('comments'),
                                isLanguageOverlayShown: path.split('/').includes('languages'),
                            }, function () {
                                _this.loadImages();
                                _this.showTitleSnackbar();
                                if (isLastPage_1)
                                    _this.showLastSnackbar(3800);
                            });
                        }
                        return [3, 5];
                    case 4:
                        err_1 = _d.sent();
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    Episode.prototype.hideTitleSnackbar = function () {
        var _this = this;
        this.setState({
            titleSnackbarTimeout: setTimeout(function () {
                _this.setState({
                    isTitleSnackbarShown: false,
                    titleSnackbarTimeout: undefined,
                });
            }, 2800),
        });
    };
    Episode.prototype.showTitleSnackbar = function () {
        var _this = this;
        var titleSnackbarTimeout = this.state.titleSnackbarTimeout;
        if (titleSnackbarTimeout) {
            clearTimeout(titleSnackbarTimeout);
            this.hideTitleSnackbar();
        }
        else {
            setTimeout(function () {
                _this.setState({
                    isTitleSnackbarShown: true,
                }, _this.hideTitleSnackbar);
            }, 300);
        }
    };
    Episode.prototype.showLastSnackbar = function (delayTime) {
        var _this = this;
        if (delayTime === void 0) { delayTime = 1000; }
        setTimeout(function () {
            _this.setState({
                isLastSnackBarShown: true,
            });
        }, delayTime);
    };
    Episode.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, prevEpSlug, prevPageNumber, _b, comicSlug, episodeSlug, pageNumber, numPageNumber, comic_1, isLastPage_2, urlElems;
            var _this = this;
            return __generator(this, function (_c) {
                _a = prevProps.match.params, prevEpSlug = _a.episodeSlug, prevPageNumber = _a.pageNumber;
                _b = this.props.match.params, comicSlug = _b.comicSlug, episodeSlug = _b.episodeSlug, pageNumber = _b.pageNumber;
                numPageNumber = Number(pageNumber);
                if (prevEpSlug !== episodeSlug) {
                    comic_1 = this.state.comic;
                    this.resetState(function () { return __awaiter(_this, void 0, void 0, function () {
                        var lang, episode, _a, prevEpisode, nextEpisode;
                        var _this = this;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    lang = lang_service_1.default.getComicLang();
                                    return [4, data_service_1.default.getCachedEpisodeBySlug(comicSlug, episodeSlug, lang, true)];
                                case 1:
                                    episode = _b.sent();
                                    _a = data_service_1.default.getPrevAndNextEpisodes(episode, comic_1.episodes), prevEpisode = _a[0], nextEpisode = _a[1];
                                    this.setState({
                                        comic: comic_1,
                                        episode: episode,
                                        pageNumber: numPageNumber,
                                        prevEpisode: prevEpisode,
                                        nextEpisode: nextEpisode,
                                        isFirstEpisode: !prevEpisode,
                                        isLastEpisode: !nextEpisode,
                                        currentImgUrl: '',
                                        loadedImages: {},
                                        isCommentsOverlayShown: false,
                                        isEpisodesOverlayShown: false,
                                        isLanguageOverlayShown: false,
                                        isEpisodePasswordVerified: false,
                                        isLastSnackBarShown: false,
                                    }, function () {
                                        _this.loadImages();
                                        _this.showTitleSnackbar();
                                    });
                                    return [2];
                            }
                        });
                    }); });
                }
                else if (prevPageNumber !== pageNumber) {
                    isLastPage_2 = numPageNumber === this.state.episode.pageCount;
                    this.setState(function (prevState) { return ({
                        pageNumber: numPageNumber,
                        currentImgUrl: prevState.loadedImages[numPageNumber]
                            ? _this.getImgUrl(numPageNumber)
                            : prevState.currentImgUrl,
                    }); }, function () {
                        _this.loadImages();
                        pageContainer.current.scrollTop = 0;
                        if (isLastPage_2)
                            _this.showLastSnackbar();
                    });
                }
                else if (prevProps.location.search !== this.props.location.search) {
                    return [2, this.setState({
                            episode: undefined,
                            isLanguageOverlayShown: false,
                            loadedImages: {},
                            currentImgUrl: '',
                        }, function () { return __awaiter(_this, void 0, void 0, function () {
                            var lang, episodeWithNewMedia;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        lang = lang_service_1.default.getComicLang();
                                        return [4, data_service_1.default.getCachedEpisodeBySlug(comicSlug, episodeSlug, lang, true)];
                                    case 1:
                                        episodeWithNewMedia = _a.sent();
                                        this.setState({
                                            episode: episodeWithNewMedia,
                                        }, function () {
                                            _this.loadImages();
                                        });
                                        return [2];
                                }
                            });
                        }); })];
                }
                else if (prevProps.match.url !== this.props.match.url) {
                    urlElems = this.props.match.url.split('/');
                    if (urlElems.includes('episode-list')) {
                        return [2, this.setState({
                                isEpisodesOverlayShown: true,
                            })];
                    }
                    else if (urlElems.includes('comments')) {
                        return [2, this.setState({
                                isCommentsOverlayShown: true,
                            })];
                    }
                    else if (urlElems.includes('languages')) {
                        return [2, this.setState({
                                isLanguageOverlayShown: true,
                            })];
                    }
                    else {
                        return [2, this.setState({
                                isEpisodesOverlayShown: false,
                                isCommentsOverlayShown: false,
                                isLanguageOverlayShown: false,
                            })];
                    }
                }
                return [2];
            });
        });
    };
    Episode.prototype.componentWillUnmount = function () {
        this.componentIsMounted = false;
        if (web_view_service_1.default.isWebView()) {
            window.removeEventListener('backButtonPressed', this.backButtonPressedHandler);
        }
    };
    Episode.prototype.loadImage = function (pageNumber) {
        var _this = this;
        var loadedImages = this.state.loadedImages;
        if (loadedImages[pageNumber])
            return Promise.resolve(true);
        return new Promise(function (resolve) {
            var img = new Image();
            img.onload = function () { return (_this.componentIsMounted &&
                _this.setState(function (prevState) {
                    var _a;
                    return ({
                        loadedImages: __assign(__assign({}, prevState.loadedImages), (_a = {}, _a[pageNumber] = true, _a)),
                        currentImgUrl: prevState.pageNumber === pageNumber
                            ? _this.getImgUrl(pageNumber)
                            : prevState.currentImgUrl,
                    });
                }, function () {
                    resolve(true);
                })); };
            img.src = _this.getImgUrl(pageNumber);
        });
    };
    Episode.prototype.loadImages = function () {
        var _this = this;
        var _a = this.state, pageNumber = _a.pageNumber, episode = _a.episode;
        this.loadImage(pageNumber).then(function () {
            if (pageNumber > 2)
                _this.loadImage(pageNumber - 1);
            if (pageNumber < episode.pageCount)
                _this.loadImage(pageNumber + 1);
        });
    };
    Episode.prototype.render = function () {
        var _this = this;
        var _a = this.state, episode = _a.episode, comic = _a.comic;
        if (!episode || !comic)
            return react_1.default.createElement(loading_1.default, null);
        var _b = this.state, pageNumber = _b.pageNumber, loadedImages = _b.loadedImages, isCommentsOverlayShown = _b.isCommentsOverlayShown, isEpisodesOverlayShown = _b.isEpisodesOverlayShown, isLanguageOverlayShown = _b.isLanguageOverlayShown, isTitleSnackbarShown = _b.isTitleSnackbarShown, isLastSnackBarShown = _b.isLastSnackBarShown, isEpisodePasswordVerified = _b.isEpisodePasswordVerified;
        var isLastPage = pageNumber === episode.pageCount;
        var isFirstPage = pageNumber === 1;
        var getLabel = lang_service_1.default.getLabel;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(meta_1.default, { author: episode.author, title: !comic.isOneShot
                    ? "".concat(getLabel(comic.title), ": ").concat(episode.sequenceCode, ": ").concat(getLabel(episode.title))
                    : getLabel(comic.title), description: !comic.isOneShot
                    ? getLabel(episode.about)
                    : getLabel(comic.shortDesc), keywords: getLabel(comic.tags), canonical: "/".concat(comic.slug, "/episodes/").concat(episode.slug, "/"), imagePath: "".concat(episode.media.thumbnail) }),
            react_1.default.createElement(snackbar_1.default, { isOpen: isTitleSnackbarShown },
                react_1.default.createElement("div", { className: "episode__snack" },
                    react_1.default.createElement("p", { className: "episode__snack-small-text" }, getLabel('nowReading')),
                    react_1.default.createElement("h3", { className: "episode__snack-title" },
                        !comic.isOneShot ? "".concat(episode.sequenceCode, ": ") : '',
                        getLabel(episode.title)))),
            react_1.default.createElement(snackbar_1.default, { isOpen: isLastSnackBarShown && isLastPage && !isTitleSnackbarShown },
                react_1.default.createElement("div", { className: "episode__snack episode__snack--last" },
                    react_1.default.createElement("h3", { className: "episode__snack-title" }, getLabel('enjoyedTheEpisode')),
                    react_1.default.createElement("div", { className: "episode__snack-sharer-container" },
                        react_1.default.createElement(sharer_1.default, { href: comic.isOneShot ? "/".concat(comic.slug, "/") : "/".concat(comic.slug, "/episodes/").concat(episode.slug, "/") })),
                    react_1.default.createElement("button", { className: "episode__snack-btn", onClick: this.showCommentsOverlay },
                        react_1.default.createElement("span", { className: "icon icon-comments-2" }),
                        getLabel('leaveACommentBtn')),
                    !episode.isLastEpisode &&
                        react_1.default.createElement("button", { className: "episode__snack-btn", onClick: function () { return _this.goToNextEpisode(); } },
                            react_1.default.createElement("span", { className: "icon icon-play" }),
                            getLabel('nextEpisodeBtn')))),
            react_1.default.createElement("article", { className: "episode" },
                react_1.default.createElement("div", { className: (0, classnames_1.default)('episode__spinner-container', {
                        'is-visible': !loadedImages[pageNumber],
                    }) },
                    react_1.default.createElement("span", { className: "episode__spinner" },
                        react_1.default.createElement(spinner_1.default, null))),
                react_1.default.createElement("div", { ref: pageContainer, onScroll: this.handleScroll, className: "episode__page-container" },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('js-page-prev', 'episode__arrow', 'episode__arrow--left', {
                            'is-disabled': isFirstPage,
                        }), ref: pageArrowLeft },
                        react_1.default.createElement(action_button_1.default, { noHover: true, icon: false && isFirstPage ? 'last-chevron-left' : 'chevron-left' })),
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('js-page-next', 'episode__arrow', 'episode__arrow--right', {
                            'is-disabled': isLastPage,
                        }), ref: pageArrowRight },
                        react_1.default.createElement(action_button_1.default, { noHover: true, icon: false && isLastPage ? 'last-chevron-right' : 'chevron-right' })),
                    react_1.default.createElement(react_2.Swiper, { spaceBetween: 10, slidesPerView: 1, initialSlide: pageNumber - 1, keyboard: {
                            enabled: true,
                        }, navigation: {
                            prevEl: '.js-page-prev',
                            nextEl: '.js-page-next',
                        }, onSlideChange: function (swiper) {
                            _this.goToPage(swiper.activeIndex + 1);
                        } }, episode.media.pages.map(function (pageImgUrl, inx) {
                        return (react_1.default.createElement(react_2.SwiperSlide, { key: inx }, !loadedImages[inx + 1] ? react_1.default.createElement("br", null) :
                            react_1.default.createElement("img", { className: "page", src: pageImgUrl })));
                    }))),
                react_1.default.createElement("span", { className: "episode__actions episode__actions--landscape" },
                    react_1.default.createElement("span", { className: "episode__actions-top" },
                        react_1.default.createElement(action_button_1.default, { icon: "home", onClick: this.goHome },
                            react_1.default.createElement("span", { className: "episode__actions-top-label" }, getLabel('backToComicBtn'))),
                        !comic.isOneShot &&
                            react_1.default.createElement(action_button_1.default, { icon: "list", onClick: this.showEpisodesOverlay },
                                react_1.default.createElement("span", { className: "episode__actions-top-label" }, getLabel('episodeListBtn'))),
                        react_1.default.createElement(action_button_1.default, { icon: "comments-2", onClick: this.showCommentsOverlay },
                            react_1.default.createElement("span", { className: "episode__actions-top-label" }, getLabel('leaveACommentBtn'))),
                        react_1.default.createElement(action_button_1.default, { icon: "language", onClick: this.showLanguageOverlay },
                            react_1.default.createElement("span", { className: "episode__actions-top-label" }, getLabel('language'))))),
                react_1.default.createElement("span", { className: "episode__actions episode__actions--portrait" },
                    react_1.default.createElement("span", { className: "episode__actions-bottom" },
                        react_1.default.createElement("span", { className: "episode__actions-bottom-container" },
                            react_1.default.createElement(action_button_1.default, { isDisabled: isFirstPage, isMobile: true, icon: "chevron-left", extraClasses: ['js-page-prev'] }),
                            react_1.default.createElement(action_button_1.default, { isMobile: true, icon: "home", onClick: this.goHome }),
                            !comic.isOneShot && react_1.default.createElement(action_button_1.default, { isMobile: true, icon: "list", onClick: this.showEpisodesOverlay }),
                            react_1.default.createElement(action_button_1.default, { isMobile: true, icon: "comments-2", onClick: this.showCommentsOverlay }),
                            react_1.default.createElement(action_button_1.default, { isMobile: true, icon: "language", onClick: this.showLanguageOverlay }),
                            react_1.default.createElement(action_button_1.default, { isDisabled: isLastPage, isMobile: true, icon: "chevron-right", extraClasses: ['js-page-next'] }))))),
            react_1.default.createElement(overlay_1.default, { isOpen: isCommentsOverlayShown, onClose: this.hideCommentsOverlay },
                react_1.default.createElement(episode_comments_1.default, { comic: comic, episode: episode })),
            react_1.default.createElement(overlay_1.default, { isOpen: isEpisodesOverlayShown, onClose: this.hideEpisodesOverlay },
                react_1.default.createElement(episode_list_1.default, { comic: comic, currentEpisode: episode, onEpisodeClick: this.goToEpisode })),
            react_1.default.createElement(overlay_1.default, { isOpen: isLanguageOverlayShown, onClose: this.hideLangOverlay },
                react_1.default.createElement(episode_languages_1.default, { comic: comic, onLanguageClick: this.changeLanguage })),
            react_1.default.createElement(overlay_1.default, { isOpen: episode.isPasswordProtected && !isEpisodePasswordVerified, onClose: this.hidePasswordOverlay },
                react_1.default.createElement(episode_password_1.default, { episode: episode, onPasswordVerified: this.passwordVerifiedHandler }))));
    };
    return Episode;
}(react_1.Component));
exports.default = Episode;
